module.exports = __webpack_public_path__ + "img/bubble-checkmark.d4c5c7e1.svg";